import React, { useState, useEffect } from 'react';
import axios from 'axios';  // <- importar axios
import { Box, Button, Modal, Typography } from '@mui/material';
import Swal from 'sweetalert2';
import './GestionDirecta.css';
import Servicios from '../Gestion/Servicios';
import SeleccionarProducto from '../SeleccionarProducto';
import VerFactura from '../Gestion/verFactura';

const GestionDirecta = () => {
  const [idTicketGenerado, setIdTicketGenerado] = useState(null);
  const [ventaData, setVentaData] = useState({
    id_empleado: 1,
    total: 0,
    tipo_pago: 'tarjeta',
    detalles: []
  });
  useEffect(() => {
    console.log("ventaData actualizado:", ventaData);
  }, [ventaData]);
  
  const [empleadosConEntrada, setEmpleadosConEntrada] = useState([]);
  const [modalTipoPagoOpen, setModalTipoPagoOpen] = useState(false);

  // Cargar empleados con entrada al montar el componente
  useEffect(() => {
    axios.get(`${process.env.REACT_APP_API_URL}/api/fichajeconEntrada`)
      .then(res => {
        setEmpleadosConEntrada(res.data);
      })
      .catch(err => {
        console.error('Error cargando empleados:', err);
      });
  }, []);




  const handleEmpleadoChange = (tipo, index, idEmpleado) => {
    setVentaData(prev => {
      const nuevosDetalles = [...prev.detalles];
  
      if (tipo === 'Producto' && nuevosDetalles[index]) {
        nuevosDetalles[index] = {
          ...nuevosDetalles[index],
          id_empleado: idEmpleado
        };
      }
  
      return {
        ...prev,
        detalles: nuevosDetalles
      };
    });
  };
  

  const handleSeleccionProducto = (producto) => {
    const nuevoDetalle = {
      nombre: producto.nombre_producto || producto.nombre,
      precio: producto.precio,
      cantidad: 1,
      subtotal: producto.precio * 1,
      id_empleado: null  // <- AGREGAR ESTO
    };
  
    setVentaData(prev => {
      const detallesActualizados = [...prev.detalles, nuevoDetalle];
      const totalActualizado = detallesActualizados.reduce((sum, item) => sum + item.subtotal, 0);
  
      return {
        ...prev,
        detalles: detallesActualizados,
        total: parseFloat(totalActualizado.toFixed(2))
      };
    });
  };
  
  const confirmarPago = async (tipoPagoSeleccionado) => {
    setModalTipoPagoOpen(false);
    setVentaData(prev => ({ ...prev, tipo_pago: tipoPagoSeleccionado }));

    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/api/crearticketdirecto`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ ...ventaData, tipo_pago: tipoPagoSeleccionado }),
      });

      const data = await response.json();

      if (response.ok) {
        Swal.fire('¡Venta completada!', 'El ticket ha sido generado.', 'success');
        setIdTicketGenerado(data.id_ticket);
      } else {
        Swal.fire('Error', data.message || 'No se pudo generar el ticket.', 'error');
      }
    } catch (error) {
      Swal.fire('Error', error.message || 'Algo salió mal', 'error');
    }
  };

  const handleAbrirModalTipoPago = () => {
    setModalTipoPagoOpen(true);
  };

  return (
    <Box className="gestion-directa-container container-fluid">
      <div className="gestion-directa-row">
        {/* Columna izquierda */}
        <div className="gestion-directa-left">
          <Box sx={{ width: '100%' }}>
            <SeleccionarProducto onSeleccion={handleSeleccionProducto} />
          </Box>
        </div>

        {/* Columna derecha */}
        <div className="gestion-directa-right">
          <Box sx={{ width: '100%' }}>
            <Servicios
              citaData={{
                tratamientos: [],
                productos: ventaData.detalles

                  
              }}
              onEmpleadoChange={handleEmpleadoChange}
              onEliminarTratamiento={() => {}}
              onEliminarProducto={() => {}}
              onActualizarCitaData={() => {}}
              onActualizarEstadoTicket={() => {}}
            />
            <Button
              variant="contained"
              color="primary"
              sx={{ mt: 2, width: '100%' }}
              onClick={handleAbrirModalTipoPago}
            >
              Cobrar
            </Button>
          </Box>
        </div>
      </div>

      {/* Modal para elegir tipo de pago */}
      <Modal
        open={modalTipoPagoOpen}
        onClose={() => setModalTipoPagoOpen(false)}
      >
        <Box sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: 300,
          bgcolor: 'background.paper',
          boxShadow: 24,
          p: 4,
          borderRadius: 2,
          textAlign: 'center',
        }}>
          <Typography variant="h6" mb={2}>Seleccione tipo de pago</Typography>
          <Button
            variant="contained"
            color="primary"
            sx={{ mr: 1 }}
            onClick={() => confirmarPago('tarjeta')}
          >
            Tarjeta
          </Button>
          <Button
            variant="contained"
            color="secondary"
            onClick={() => confirmarPago('efectivo')}
          >
            Efectivo
          </Button>
        </Box>
      </Modal>

      {/* Modal para VerFactura */}
      <Modal
        open={Boolean(idTicketGenerado)}
        onClose={() => setIdTicketGenerado(null)}
      >
        <Box sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: '25vw',
          minHeight: '80vh',
          maxHeight: '90vh',
          overflowY: 'auto',
          bgcolor: 'background.paper',
          boxShadow: 24,
          p: 4,
          borderRadius: 2
        }}>
          <VerFactura
            idTicket={idTicketGenerado}
            onCancelarImpresion={() => setIdTicketGenerado(null)}
            empleados={empleadosConEntrada}  // <- pasamos empleados aquí
          />
        </Box>
      </Modal>
    </Box>
  );
};

export default GestionDirecta;
